/* Duskhaven USB wall charger add-on (2026-10-02, Todd). Loaded from snippets/dh-head.liquid.
 * 1. Product page: when the "Add a USB wall charger" box (snippets/dh-addon-charger.liquid) is ticked, the theme's own
 *    Add to cart (main button or sticky bar, which clicks the main button) sends the charger in the same /cart/add.js
 *    request: the theme builds its request with new FormData(form), which fires a "formdata" event, and this adds
 *    items[][id] / items[][quantity] for the charger next to the product's id / quantity. The box is then cleared so a
 *    second Add to cart does not add a second charger.
 * 2. Cart drawer / cart page: "Add" on the charger suggestion (snippets/dh-addon-cart-suggest.liquid) adds one charger
 *    and refreshes the cart in place through the theme's cart events. If anything fails it follows the link
 *    (/cart/add?id=...), which adds it and opens the cart page. */
(function () {
  'use strict';
  if (window.__dhAddon) return;
  window.__dhAddon = true;

  /* ---------- 1. Product page: add the charger with the product ---------- */
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var box = form.querySelector('[data-dh-addon-check]');
    if (!box || !box.checked) return;
    var addonId = box.getAttribute('data-variant-id');
    var mainId = event.formData.get('id');
    if (!addonId || !mainId || String(mainId) === String(addonId)) return;
    event.formData.append('items[][id]', addonId);
    event.formData.append('items[][quantity]', '1');
    setTimeout(function () { box.checked = false; }, 0);
  }, true);

  /* ---------- 2. Cart suggestion ---------- */
  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = new Promise(function (resolve) {
        var done = function () { resolve(window.__dhShopifyEvents || null); };
        if (window.__dhShopifyEvents) { done(); return; }
        document.addEventListener('dh:shopify-events', done, { once: true });
        setTimeout(done, 3000);
        var script = document.createElement('script');
        script.type = 'module';
        script.textContent = "import('@shopify/events').then(function (m) { window.__dhShopifyEvents = m; })" +
          ".catch(function () {}).then(function () { document.dispatchEvent(new Event('dh:shopify-events')); });";
        document.head.appendChild(script);
      });
    }
    return eventsModule;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element ? event.target.closest('[data-dh-addon-add]') : null;
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    link.setAttribute('aria-disabled', 'true');
    var label = link.textContent;
    link.textContent = 'Adding…';
    var variantId = link.getAttribute('data-variant-id');

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (element) {
      if (element.dataset && element.dataset.sectionId && sectionIds.indexOf(element.dataset.sectionId) === -1) {
        sectionIds.push(element.dataset.sectionId);
      }
    });

    loadEvents().then(function (events) {
      var Update = events && events.CartLinesUpdateEvent;
      var deferred = Update ? Update.createPromise() : null;
      if (deferred) {
        link.dispatchEvent(new Update({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));
      }
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
        credentials: 'same-origin'
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result.status) throw new Error(result.description || result.message || 'Could not add to cart');
          return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              if (deferred) {
                deferred.resolve({
                  cart: Update.createCartFromAjaxResponse(cart),
                  detail: { items: cart.items, source: 'dh-addon', itemCount: 1, sections: result.sections, didError: false }
                });
              } else {
                window.location.href = rootUrl() + 'cart';
              }
            });
        })
        .catch(function (error) {
          if (deferred) deferred.reject(error);
          link.removeAttribute('aria-disabled');
          link.textContent = label;
          window.location.href = link.href;
        });
    });
  });
})();
